const print = {
	$window: $(window),
	elem: {
		$trigger: $('.js-print')
	},

	init() {
		this.bindUIActions();
	},
	
	printPage(e) {
		e.preventDefault();
		print.$window[0].print();
	},
	
	bindUIActions() {
		this.elem.$trigger.each(function(){
			this.addEventListener('click', print.printPage);
		});
	}
};

export { print };
